module.exports = __webpack_public_path__ + "img/senior.cd175f88.png";